import { RENTAL_LOGOS } from "@/components/auto/RentalLogo";

// Car rental companies that actually operate in Puerto Rico: the airport
// brands a visitor lands on, and the island-owned counters that beat their
// rates. `local` marks the boricua-owned companies, which lead the section.
// `logo` is the company's own mark; `mark` is the letter used if one is ever
// missing. `bleed` marks artwork that is already a flat coloured square, so it
// fills its tile instead of floating inside it.
const company = (entry) => ({ ...entry, logo: RENTAL_LOGOS[entry.name] || "" });

export const RENTAL_COMPANIES = [
  {
    name: "Charlie Car Rental",
    blurb_en: "Boricua-owned, with pickup right by the airport in Isla Verde.",
    blurb_es: "Empresa boricua, con recogida junto al aeropuerto en Isla Verde.",
    url: "https://charliecars.com",
    mark: "C",
    local: true,
  },
  {
    name: "Target Rent a Car",
    blurb_en: "Island-owned, with pickups in San Juan and around the metro.",
    blurb_es: "Empresa local, con recogida en San Juan y el área metro.",
    url: "https://www.targetrentacar.com",
    mark: "T",
    local: true,
  },
  {
    name: "Avis",
    blurb_en: "Counters at SJU and the convention hotels.",
    blurb_es: "Mostradores en SJU y hoteles del área.",
    url: "https://www.avis.com/en/locations/pr",
    mark: "A",
    bleed: true,
  },
  {
    name: "Sixt",
    blurb_en: "Premium fleet, quick airport pickup.",
    blurb_es: "Flota premium, recogida rápida en el aeropuerto.",
    url: "https://www.sixt.com/car-rental/puerto-rico/",
    mark: "S",
    bleed: true,
  },
  {
    name: "Enterprise",
    blurb_en: "Island-wide branches, one-way friendly.",
    blurb_es: "Sucursales en toda la isla, entrega en otra ciudad.",
    url: "https://www.enterprise.com/en/car-rental/locations/puerto-rico.html",
    mark: "E",
  },
  {
    name: "Hertz",
    blurb_en: "Airport desks and loyalty perks.",
    blurb_es: "Mostradores en el aeropuerto y beneficios de socio.",
    url: "https://www.hertz.com/rentacar/location/puerto%20rico",
    mark: "H",
    bleed: true,
  },
  {
    name: "Budget",
    blurb_en: "The cheapest of the big airport brands.",
    blurb_es: "La opción más económica de las grandes marcas.",
    url: "https://www.budget.com/en/locations/pr",
    mark: "B",
  },
].map(company);